<template>
  <div :class="$style.box">
    <div
      v-for="item in hmGameList"
      :key="item.id"
      :class="$style['game-list']"
      @click="handleLinkTo(item.url)"
    >
      <img :src="item.images" alt="游戏图标" />
      <div :class="$style.info">
        <p>{{ item.name }}</p>
        <div>{{ item.description }}</div>
      </div>
      <div :class="$style.download">{{ item.id == 140 ? '启动' : '下载' }}</div>
    </div>
  </div>
</template>

<script>
import { reportData } from '@/api/report';
export default {
  props: {
    hmGameList: { type: Array, default: () => [] },
  },
  data() {
    return {};
  },
  methods: {
    handleLinkTo(url) {
      reportData({
        type: 2, // 进入游戏中心
        data_type: 2,
      });
      window.open(url, '_self');
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  min-height: 64px;
  padding-top: 10px;
  .game-list {
    width: 100%;
    height: 44px;
    margin-bottom: 17px;
    display: flex;
    > img {
      width: 44px;
      margin-right: 5px;
      border-radius: 10px;
    }
    .info {
      width: 220px;
      height: 44px;
      margin-top: 4px;
      p {
        font-size: 11px;
        font-weight: 400;
        line-height: 18px;
      }
      div {
        font-size: 10px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
        line-height: 14px;
      }
    }
    .download {
      width: 48px;
      height: 22px;
      background: linear-gradient(-75deg, rgba(255, 73, 73, 1), rgba(255, 143, 94, 1));
      border-radius: 11px;
      text-align: center;
      line-height: 22px;
      color: white;
      font-size: 10px;
      margin: 11px 0px 0px 9px;
    }
  }
}
</style>
